const rootActionPath = 'core/InstoreOfferModal';

export const INSTORE_OFFER_MODAL_TRIGGER = `${rootActionPath}/TRIGGER`;
export const INSTORE_OFFER_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
